/* eslint-disable */
// Shared dev-list projection — Strategy γ unified projection per T-1003.
// Used by useAppData (Path A + Path B) and useDevsPaginated to prevent
// Path B's select("*") fallback from pulling 30-90 MB of nested JSONB on
// cold portal entry.
//
// DevDetailModal self-fetches select("*") per row via useDevDetail.js:88
// — do NOT add cardActivity, stageDurations, or finalColorPhotos to this
// list (those fields drive DevDetail-only views and would re-inflate
// payload back to 30+ MB).
//
// Field consumers:
//   - rounds → useDesignerAggregates.js:119 rework count
//   - shape1/2/3, color, gender, geo → DevCardNew, BasedOnPickers, filters
//   - primaryImageIndex → image carousel default index
//   - stageStartedAt, completedAt → stage-duration UI badges
//   - All other fields → existing Path A consumers

export const DEV_LIST_SELECT = [
  // top-level columns (6)
  'id', 'created_at', 'updated_at', 'stop_reason', 'completion_stage', 'import_batch_id',
  // identity / classification (5)
  'data->dev_number', 'data->dev_type', 'data->designer', 'data->fty', 'data->material',
  // status (3)
  'data->stage_status', 'data->full_status', 'data->prev_status',
  // deadline (2) — Stage 1/2 urgency inputs. status_set_at drives
  // getStatusUrgency (card border + DeadlinePanel); deadline_extension_days
  // honors per-dev postponements (Stage 2 postpone RPC). Without these the
  // helper's dual-read starves to state='unknown' on every board card.
  'data->status_set_at', 'data->deadline_extension_days', 'data->deadline_snoozed_until',
  // timeline / lifecycle (5)
  'data->dev_date', 'data->drawing_date', 'data->stageStartedAt', 'data->completedAt', 'data->rounds',
  // visual (6)
  'data->images', 'data->primaryImageIndex', 'data->shape', 'data->shape1', 'data->shape2', 'data->shape3',
  // attributes (5)
  'data->sun_optic', 'data->season', 'data->year', 'data->gender', 'data->geo',
  // sourcing (3)
  'data->based_on', 'data->based_on_data', 'data->collection',
  // selection decision (1) — BRIEF 7: read-only Apply stamp
  // (data.selections['<season>'].decision). Drives the Selection chip on board
  // cards. Object-valued (-> not ->>). The DevDetail modal self-fetches
  // select('*') so it needs no projection key.
  'data->selections',
  // ops (5)
  'data->archived', 'data->ordered', 'data->cl_assigned', 'data->po_number', 'data->model',
  // search-helper (3) — Brief 7.1: do_number added so Board search can match
  // it client-side; server-side .or() in useDevsPaginated.js:131 also extended.
  'data->color', 'data->notes', 'data->do_number',
  // import provenance (4)
  'data->import_batch', 'data->imported', 'data->import_batch_id', 'data->created_by',
  // attribution (1)
  'data->created_by_name',
].join(',');
